import { useEffect, useRef, MutableRefObject } from "react"

interface IntersectionObserverHook {
  observe: (element: Element) => void
  unobserve: (element: Element) => void
}

export const useIntersectionObserver = (
  callback: (entry: IntersectionObserverEntry) => void,
  options?: IntersectionObserverInit
): IntersectionObserverHook => {
  const observer: MutableRefObject<IntersectionObserver | null> = useRef(null)

  useEffect(() => {
    if (observer.current) observer.current.disconnect()

    observer.current = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (callback) callback(entry)
      })
    }, options)

    return () => {
      if (observer.current) observer.current.disconnect()
    }
  }, [callback, options])

  const observe = (element: Element): void => {
    if (element && observer.current) observer.current.observe(element)
  }

  const unobserve = (element: Element): void => {
    if (element && observer.current) observer.current.unobserve(element)
  }

  return { observe, unobserve }
}
